// src/components/common/SafeImg.tsx
import React, { useEffect, useMemo, useState } from "react";
import { resolveImg, FALLBACK_IMG } from "../../utils/media";

type SafeImgProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  "src" | "onError"
> & {
  src?: string | null;
  /** Optional override fallback image */
  fallbackSrc?: string;
  /** Keep user's onError callback */
  onError?: React.ImgHTMLAttributes<HTMLImageElement>["onError"];
};

export default function SafeImg({
  src,
  fallbackSrc = FALLBACK_IMG,
  onError,
  loading,
  decoding,
  referrerPolicy,
  ...rest
}: SafeImgProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const resolvedSrc = useMemo(() => resolveImg(src), [src]);
  const finalSrc = failed ? fallbackSrc : resolvedSrc;

  return (
    <img
      {...rest}
      src={finalSrc}
      loading={loading ?? "lazy"}
      decoding={decoding ?? "async"}
      referrerPolicy={referrerPolicy ?? "no-referrer-when-downgrade"}
      onError={(e) => {
        // ✅ nếu đã fail rồi hoặc đang ở fallback mà vẫn lỗi -> không setState nữa
        if (!failed && finalSrc !== fallbackSrc) {
          setFailed(true);
        }
        onError?.(e);
      }}
    />
  );
}
